import _ from "lodash";
import moment from "moment-timezone";
import React, { useEffect } from "react";
import styled from "styled-components";
import { breakpoints, colors } from "../../styles/variables";
import EventDates from "./EventDates";

const DataElem = styled.div`
  text-transform: uppercase;
  font: 15px / 18px "Slate Regular";
  margin-bottom: 26px;

  .whiteFont {
    > div {
      padding: 8px 12px;
      color: white;
    }

    > div:first-of-type {
      //replace with color prop
      background: ${(props) =>
        colors[
          props.color
            ?.toLowerCase()
            .replace("-", "")
            .replace("/", "")
            .replace(" ", "")
            .replace(" ", "")
        ]};
    }

    > div:last-of-type {
      background: ${colors.text};
    }
  }

  .dateTime {
    padding: 8px 12px;
    background: ${colors.lightGray};
  }

  @media screen AND (min-width: ${breakpoints.tablet}px) {
    .whiteFont {
      display: grid;
      grid-template-columns: auto 1fr;
    }
  }

  @media screen AND (min-width: ${breakpoints.desktop}px) {
    font: 21px / 25px "Slate Light";
    margin-bottom: 50px;
  }
`;

const EventData = ({ type, date, endDate, place, showtime, relatedEvents }) => (
  <DataElem color={type}>
    <div className="whiteFont">
      <div>{type.toUpperCase()}</div>
      <div>{place.toUpperCase()}</div>
    </div>
    <div className="dateTime">
      <EventDates
        relatedEvents={relatedEvents}
        date={date}
        showtime={showtime}
        endDate={endDate}
      />
      <br />
    </div>
  </DataElem>
);

export default EventData;
